import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../../UI/Buttons';
import { Title, Text } from '../../UI/Typography';

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Modal = styled(motion.div)`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
  text-align: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
`;

const CancelButton = styled(Button)`
  background-color: #28a745;
  color: white;
  border: none;
  min-width: 80px;
  
  &:hover {
    background-color: #218838;
  }
`;

const DeleteButton = styled(Button)`
  background-color: #dc3545;
  color: white;
  border: none;
  min-width: 80px;
  
  &:hover {
    background-color: #c82333;
  }
`;

const ConfirmationModal = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  title = "Confirm Action",
  message,
  confirmText = "Yes",
  cancelText = "Cancel",
  confirmVariant = "primary"
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <Overlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onCancel}
        >
          <Modal
            initial={{ scale: 0.7, opacity: 0, y: -100 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.7, opacity: 0, y: -100 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}
          >
            <Title as="h3" style={{ marginBottom: '1rem', color: '#333' }}>
              {title}
            </Title>
            
            <Text style={{ marginBottom: '1.5rem', color: '#666', lineHeight: '1.5' }}>
              {message}
            </Text>
            
            <ButtonGroup>
              <CancelButton onClick={onCancel}>
                {cancelText}
              </CancelButton>
              <DeleteButton onClick={onConfirm}>
                {confirmText}
              </DeleteButton>
            </ButtonGroup>
          </Modal>
        </Overlay>
      )}
    </AnimatePresence>
  );
};

export default ConfirmationModal;